<template lang="pug">

    div

        p Auflage: {{ printing }}

        price-table(
            v-bind:additional-cost-models='additionalCostModels'
            v-bind:job-models='jobModels'
            v-bind:offer-models='offerModels'
            v-bind:price-models='priceModels'
            v-bind:product-model='productModel'
            v-bind:supplier-models='supplierModels'
            v-show="priceModels.length > 0"
        )

        p.ui.info.message(v-show="priceModels.length === 0")
            | Noch keine Preise für diese Auflage vorhanden

</template>

<script>
    import PriceTable from './printing-prices/PriceTable'

    export default {

        components: { PriceTable },

        props: {

            additionalCostModels: {
                type: Array,
                required: true
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            priceModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            printing: {
                type: Number,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
